import { get, post, put, del, publicGet } from './_httpClient';

export async function searchPublications({ q, pageSize, page }) {
  const { status, message, data } = await publicGet(
    `/clp/publications?q=${q}&pageSize=${pageSize}&page=${page}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPublicationsBySlug({ slug }) {
  const { status, message, data } = await publicGet(`/clp/publications/${slug}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getArticles({ q = '', page, pageSize }) {
  const { status, message, data } = await get(
    `/articles?q=${q}&pageSize=${pageSize}&page=${page}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getSpecificArticles({ articleId }) {
  const { status, message, data } = await get(`/articles/${articleId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPublicationsAdmin({ publicationStatus, pageSize, page }) {
  const { status, message, data } = await get(
    `/clp/admin/publications?publicationStatus=${publicationStatus}&pageSize=${pageSize}&page=${page}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getStatusPublicationsAdmin() {
  const { status, message, data } = await get('/clp/admin/publications/status');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getPublicationsById({ id }) {
  const { status, message, data } = await get(`/clp/admin/publications/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function createPublicationReview({ id, payload }) {
  const { status, message } = await post(`/clp/admin/publications/${id}/reviews`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function updatePublicationReview({ publicationId, reviewId, payload }) {
  const { status, message } = await put(
    `/clp/admin/publications/${publicationId}/reviews/${reviewId}`,
    payload
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function deletePublicationReview({ publicationId, reviewId }) {
  const { status, message } = await del(
    `/clp/admin/publications/${publicationId}/reviews/${reviewId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}

export async function updatePublicationStatusHistory({
  publicationId,
  publicationHistoryId,
}) {
  const { status, message } = await put(
    `/clp/admin/publications/${publicationId}/status/${publicationHistoryId}`,
    {}
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return message;
}
